module.exports = __webpack_public_path__ + "media/images/custom_page/ab6ix_event2/ab6ix-event-ja-abefa88b103abfd080dd785e938a5d8f.png";